<div class="content-pane">
  <h2>Edit Resource Access</h2>
  <div class="meta-subheader lifted expanded-margin-bottom">
    {{ this.objectName }}: <a [routerLink]="['/resource-explorer/view', id]">{{ this.name }}</a>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="submit($event)">
      <formly-form [model]="model" [fields]="formFields" [options]="options" [form]="form"></formly-form>
      <div class="form-actions">
        <button matButton="filled" type="submit" [disabled]="submitting || form.status == 'PENDING'">
          <mat-icon class="material-symbols-outlined">check</mat-icon> Save
        </button>
        <a matButton="filled" class="cancelbtn" [routerLink]="['/resource-explorer/view', id]">
          <mat-icon class="material-symbols-outlined">remove_circle</mat-icon> Cancel
        </a>
      </div>
    </form>

    <div class="content-subsection" appSubsectionScroll data-subsection="delete">
      <h3>Delete Resource</h3>
      <button matButton="filled" type="button" class="danger subsection-action" (click)="deleteResource()">
        <mat-icon class="material-symbols-outlined">delete</mat-icon> Delete Resource
      </button>
    </div>
  </div>
</div>
